import { Injectable } from "@angular/core";
import { TranslocoService } from "@jsverse/transloco";
import { firstValueFrom } from "rxjs";
import { retry, timeout } from "rxjs/operators";

@Injectable({ providedIn: 'root' })
export class TranslationPreloaderService {

  constructor(private translocoService: TranslocoService) {}

  async init(): Promise<void> {
    const defaultLang = 'fr';

    this.translocoService.setDefaultLang(defaultLang);

    try {
      await firstValueFrom(
        this.translocoService.load(defaultLang).pipe(
          timeout(3000),
          retry({ count: 1, delay: 500 })
        )
      );
      this.translocoService.setActiveLang(defaultLang);

      const scopes = [
        'referentiels','administration','commandeachat','configuration','contrats','contacts',
        'demande','fact','fournisseurs','gestioncompte','grille','obligationslegales',
        'prestation','producteurdechet','reporting','tgap','trackdechets','validation'
      ];
      scopes.forEach(s => this.translocoService.load(`${s}/${defaultLang}`).subscribe());
    } catch (err) {
      console.error('[i18n] Default language failed to load during bootstrap', defaultLang, err);
      setTimeout(() => this.translocoService.load(defaultLang).subscribe(), 2000);
    }
  }
}
